import { render, staticRenderFns } from "./RelClubEvent.vue?vue&type=template&id=33717290&scoped=true"
import script from "./RelClubEvent.vue?vue&type=script&lang=js"
export * from "./RelClubEvent.vue?vue&type=script&lang=js"
import style0 from "./RelClubEvent.vue?vue&type=style&index=0&id=33717290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33717290",
  null
  
)

export default component.exports